import { render, staticRenderFns } from "./FaizOranList.vue?vue&type=template&id=1c5f59b2"
import script from "./FaizOranList.vue?vue&type=script&lang=ts"
export * from "./FaizOranList.vue?vue&type=script&lang=ts"
import style0 from "./FaizOranList.vue?vue&type=style&index=0&id=1c5f59b2&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports